import clsx from 'clsx'
import { FC } from 'react'
import { BasicStyledComponent } from 'shared-definitions/types'
import styles from './ViafouraShareBar.module.css'

const VIafouraShareBar: FC<BasicStyledComponent> = ({ className }) => (
  <div className={clsx(styles.container, className)}>
    <div className="viafoura">
      <div
        className="vf-widget vf-share-bar-square vf-share-bar-bw"
        data-widget="sharebar"
        data-button-view="false"
        data-show-labels="false"
        data-show-counters="true"
        data-show-total="true"
        data-path="/"
      />
    </div>
  </div>
)

export default VIafouraShareBar
